<template>
    <div>
         <div class="mobile">
            <div class="mobile_top">
                <span  @click.prevent="onHome()">欢迎来到智污邦环保服务平台 </span>
                <span class="ml-30" @click="onJump()">帮助中心</span>
                <span class="ml-30" @click="onHome()">返回首页</span>
            </div>
            <div class="mobile_middle">
                <div class="moblie_conent">
                <el-form class="mt-20" :rules="rules"  ref="form" :model="form">
                    <h4>绑定手机账号</h4>
                    <el-form-item class="phone"  prop="mobile" style="width:100%;">
                        <img class="icon" src="../../assets/images/mobile.png" alt="">
                        <el-input class="myClass" placeholder="请输入手机号码" v-model="form.mobile"  @blur="onInputBlur" clearable></el-input>
                    </el-form-item>
                    <el-form-item class="phone"  prop="password" style="width:100%;">
                        <img class="icons" src="../../assets/images/password.png" alt="">
                        <el-input type="password"  class="myClass" placeholder="请输入登录密码" v-model="form.password" clearable></el-input>
                    </el-form-item>
                  <el-form-item  v-if="userType"  class="phone" prop="type" style="width: 100%">
                    <img class="icon" src="../../assets/images/entser.png" alt="" />
                    <el-select
                      v-model="form.type"
                      placeholder="请选择类型"
                      style="width: 100%"
                    >
                      <el-option label="个人" value="1"></el-option>
                      <el-option label="专家" value="2"></el-option>
                      <el-option label="企业" value="3"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item class="phone"  prop="name" style="width:100%;">
                        <img class="icon" src="../../assets/images/bingName.png" alt="">
                        <el-input class="myClass" placeholder="请输入姓名" v-model="form.name"  @blur="onInputBlur" clearable></el-input>
                    </el-form-item>
                  <el-form-item class="phone" prop="gender" style="width: 100%">
                    <img class="icon" src="../../assets/images/bingGender.png" alt="" />
                    <el-select
                      v-model="form.gender"
                      placeholder="请选择性别"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item,index) in genderList"
                        :key="index"
                        :label="item.value"
                        :value="item.label"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item class="phone" prop="profession" style="width: 100%">
                    <img class="icon" src="../../assets/images/ties.png" alt="" />
                    <el-select
                      v-model="form.profession"
                      placeholder="请选择所属行业"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item,index) in categoryList"
                        :key="index"
                        :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                     <el-form-item
                        class="code"
                        prop="graphicCode"
                        style="width: 100%"
                        >
                        <img
                            class="icon"
                            src="../../assets/images/security.png"
                            alt=""
                        />
                  <el-input
                    class="myClass"
                    placeholder="图形验证码"
                    v-model="form.graphicCode"
                    maxlength="5"
                  ></el-input>
                  <img
                    class="graphic_code"
                    :src="imgUrl"
                    alt=""
                    @click.prevent="getCaptcha()"
                  />
                     </el-form-item>
                     <el-form-item
                        class="shortCode"
                        prop="smsCode"
                        style="width: 100%"
                        >
                        <el-input
                            class="phoneCode"
                            placeholder="短信验证码"
                            v-model="form.smsCode"
                            maxlength="6"
                        ></el-input>
                        <button class="shortBtn" @click.prevent="onCode()">
                            {{ getCodeText }}
                        </button>
                     </el-form-item>
                     <el-form-item style="width: 100%">
                      <el-button class="reset_login" @click.prevent="onBind('form')">确定绑定</el-button>
                    </el-form-item>
                </el-form>
                </div>
                <div class="moblie_text">中国·山东环境领域“互联网+环保”务实发展为本的共享平台</div>
            </div>

        </div>
    </div>

</template>
<script>
import { getUUID } from "@/utils/index.js";
import {setToken} from '@/utils/auth'
import {getDict} from "@/api/coment"
import{getCode,checkMobiles} from "@/api/user"
export default {
    data(){
    //验证手机号规则
    var checkPhone = (rule, value, cb) => {
      // 验证手机号的正则表达式
      // const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      const regMobile = /^1\d{10}$/;
      if (regMobile.test(value)) {
        return cb();
      }
      cb(new Error("请输入合法的手机号"));
    };
    return{
        categoryList:[],
        genderList: [
          {
            value: '男',
            label: '男',
          },{
            value: '女',
            label: '女'
          }
        ],
        form:{
            mobile:'',
            type:'', //类型
            password:'', //密码
            graphicCode:'', //图形验证码
            smsCode:'',//短信验证码
            profession:'', //所属行业
            name: '', //用户姓名
            gender: '', //性别
            industry: ''  // 所属行业

        },
        rules:{
            mobile:[{ required: true, message: '请输入手机号码', trigger: 'blur' },{
            required: true,
            validator: checkPhone,
            trigger: "blur",
           },],
            type:[{ required: true, message: '请选择类型', trigger: 'change' }],
            password:[{ required: true, message: '请输入密码', trigger: 'buler' }],
            graphicCode:[{ required: true, message:'请输入图形验证码', trigger: 'buler' }],
            smsCode:[{ required: true, message:'请输入短信验证码', trigger: 'buler' }],
            profession:[{ required: true, message:'请选择所属行业', trigger: 'buler' }],
            name:[{ required: true, message:'请输用户名', trigger: 'buler' }],
            gender: [{ required: true, message:'请选择用户性别', trigger: 'buler' }],
        },
        getCodeText: "获取验证码",
        getCodeisWaiting: false,
        imgUrl:"",
        uid: "" ,
        userType:true
    }
    },
    created(){
        this.getCaptcha()
        // let token = localStorage.getItem('token');
        // setToken(token);
        this.getCailter();
    },
    methods:{
        onJump(){
          this.$router.push('/help_center')
        },
        onHome(){
        this.$router.push('/')
        },
		//检查手机是否被注册
		onInputBlur(){
	      if(this.form.mobile !=""){
		  	checkMobiles({
			  mobile:this.form.mobile
			}).then((res)=>{
        if(res.code == 0){
          if(res.msg == '1'){
            this.userType = false;
            this.form.type = 0;
          }
        }
      }).catch((err)=>{})
		  }else{
		     return false;
		  }
		},
        //获取图形验证码
        getCaptcha() {
        this.uid = getUUID();
        this.imgUrl = `/api/zwb/app/captcha.jpg?uuid=${this.uid}`;
        },
        //倒计时
        setTimer() {
            let holdTime = 60;
            this.getCodeText = "重新获取(60)";
            this.Timer = setInterval(() => {
                if (holdTime <= 0) {
                this.getCodeisWaiting = false;
                this.getCodeText = "获取验证码";
                holdTime = 60;
                clearInterval(this.Timer);
                return;
                }
                this.getCodeText = "重新获取(" + holdTime + ")";
                holdTime--;
            }, 1000);
        },
        onCode() {
            if (!this.form.mobile) {
                this.$message({
                message: "请输入手机号",
                type: "warning",
                duration: 1000,
                });
                return;
            }
            if (!this.form.graphicCode) {
                this.$message({
                message: "请输入图形验证码",
                type: "warning",
                duration: 1000,
                });
                return;
            }
            if (this.getCodeisWaiting) {
                return false;
            }
            let params = {
                mobile: this.form.mobile,
                uuid: this.uid,
                imgCode: this.form.graphicCode,
            };
            this.setTimer();
            this.getCodeisWaiting = true;
            getCode(params)
                .then((res) => {
                if (res.code == 0) {
                    this.$message({
                    message: "验证码发送成功",
                    type: "success",
                    duration: 1000,
                    });
                }
                })
                .catch((err) => {});
         },
        //绑定
        onBind(formName){
          this.$refs[formName].validate((valid) =>{
              if(valid){                
                this.$store.dispatch("user/getBind", {
                      mobile:this.form.mobile,
                      password:this.form.password,
                      // profession:this.form.profession,
                      industry: this.form.profession,
                      type:this.form.type,
                      smsCode:this.form.smsCode,
                      name: this.form.name,
                      gender: this.form.gender,                  
                    })
                    .then((res) => {
                     if(res.code == 0){
                      this.$message({
                        message: "绑定成功",
                        type: "success",
                        duration: 1000,
                        onClose: () => {				
                            localStorage.removeItem('data');
                            localStorage.removeItem('list');
                            // this.$store.dispatch("user/logout");
                            this.$router.replace("/")
                            // this.$router.push('/')
                            //toLogin();
                            // this.$router.push({path:'/login',query:{redirect:this.redirect}})
                        },
                      });
                     }
                    }).catch(() => {});
              }else{
                  return false
              }
          })
        },
      //获取分类
      getCailter(){
        let params={
          code:this.industry_type
        };
        getDict(params).then(res=>{
          if(res.code ==0){
            this.categoryList = res.data[0].children;
          }
        }).catch(err=>{});
      },
    }

}
</script>
<style scoped="scoped">
.ml-30{
    margin-left: 30px;
}
.mobile{
  background: url("../../assets/images/login.jpg") no-repeat center/cover;
  min-height: 119vh;
}
.mobile_top{
    padding: 30px 25px;
    font-size: 12px;
}
.mobile_top{
  cursor: pointer;
}
.mobile_middle{
    /* display: flex;
    justify-items: center;
    align-items: center;
    flex-direction: column;
    margin-top: 60px; */
    /* position: fixed; */
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.moblie_conent{
    width: 436px;
    /* height: 366px; */
    background:rgba(255, 255, 255, 0.8);
    padding: 40px 30px;
}
.moblie_conent>>>.el-input__inner{
  background: #ffffff;
  z-index: 100 !important;
}
.moblie_conent >>>.el-button--default:hover{
  color: #ffffff;
}
.moblie_conent h4{
    font-size: 26px;
    font-family: PingFangSC;
    font-weight: 500;
    color: #333333;
    text-align: center;
    /* margin-left: 75px; */
    /* margin-bottom: 30px; */
}
.el-form-item{
    margin-top: 20px;
}
.mobile_middle>>>.el-input__inner{
    height: 50px;
    padding-left: 40px;
}
.icon{
    width: 24px;
    height: 26px;
    position: absolute;
    top: 10px;
    left:10px;
    z-index: 100;
}
.icons {
  width: 32px;
  height: 34px;
  position: absolute;
  top: 7px;
  left: 5px;
  z-index: 100;
}
.phone{
    position: relative;
}
/deep/.phone .el-button{
     position: absolute;
     height: 50px;
     top: 0;
     right: 0;
     color: #FFFFFF;
     width: 95px;
     background: #FB7103;
     border: none;
     font-size: 12px;
}
.define{
    height: 50px;
    background: linear-gradient(104deg, #A1DB13, #69CB1D);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    border: none;
    margin-top: 20px;
}
.moblie_text{
    /* width: 521px; */
    text-align: center;
    margin-top: 15px;
    font-size: 18px;
    font-family: PingFangSC;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    margin-left: -24px;
}

.graphic_code {
  position: absolute;
  right: 0;
  top: 0;
  width: 125px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  background: #cdcdcd;
  color: #323232;
}
.shortCode {
  position: relative;
}
.shortBtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 125px;
  height: 50px;
  background: #e5e5e5;
}
.reset_login {
  width: 100%;
  height: 50px;
  background: linear-gradient(104deg, #a2dc14, #69cc1e);
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  border: none;
  color: #ffffff;
}
.reset_login:hover {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/view/other/mobile_phone.vue